import { render } from "preact";
import { App } from "./app";
import "@chatland/brand/tokens.css";
import "./styles.css";

render(<App />, document.getElementById("app")!);
